<template>
  <div class="page__main--640 logos">
    <h1 class="m-b-m">Logotypes</h1>
    <p class="m-b-xl"><fds-text type="lead">Make sure to use SVGs when possible for optimal detail and performance.</fds-text></p>

    <section class="logos__list" v-for="variant in logotypes.variants" :key="variant.title">
      <header class="logos__list__header">
        <h2 class="m-v-none">{{variant.title}}</h2>
      </header>
      <article class="content-block content-block--logo" v-for="version in variant.versions" :key="version.title">
        <div class="example" :class="[{'contrast': version.background}, `type--${version.type}`]">
          <img :src="returnPath(version.files[0].path)">
        </div>
        <div class="meta">
          <strong class="meta__heading">{{version.title}}</strong>
          <p class="meta__description" v-if="version.description">{{version.description}}</p>
          <div class="meta__links">
            <span v-for="(type) in version.files" :key="type.type">
              <fds-button variant="minor" icon="download">
               <a :href="returnPath(type.path)" download>Download {{type.type}}</a>
            </fds-button>
            </span>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import logoJson from '../../../public/assets/img/logotypes/logotypes.json'
export default {
  name: 'logos',
  data () {
    return {
    }
  },
  computed: {
    logotypes () {
      return logoJson
    }
  },
  methods: {
    returnPath (img) {
      return require(`../../../public/assets/img/logotypes/${img}`)
    }
  }
}
</script>

<style lang="scss">
.logos__list {
  margin-bottom: set-gutter('xl');
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: set-gutter('l');
    a {
      margin-left: set-gutter('l');
    }
    @media all and (min-width: 440px) {
      flex-direction: row;
    }
    fds-button {
      margin-top: set-gutter('m');
      @media all and (min-width: 440px) {
        margin-top: 0;
      }
    }
  }
}
.content-block {
  margin-bottom: set-gutter('m');
  padding: set-gutter('l');
  .example {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 260px;
    padding: set-gutter('l') 0;
    margin: 0 set-gutter('l') 0 0;
  }
  .meta {
    flex: 1;
    display: flex;
    flex-direction: column;
    > a {
      display: block;
      margin-top: auto;
    }
    &__description {
      margin: set-gutter('xs') 0 set-gutter('l') 0;
      @media all and (min-width: set-bp('m')) {
        margin: set-gutter('xs') 0 auto 0;
      }
    }
    &__links {
      display: flex;
      flex-wrap: wrap;
      column-gap: set-gutter('xl');
      row-gap: set-gutter('xs');
      @media all and (min-width: set-bp('m')) {
        margin-top: set-gutter('l');
      }
      > a {
        display: inline-block;
        margin: 0 set-gutter('s');
      }
    }
  }
  &--logo {
    display: block;
    @media all and (min-width: set-bp('m')) {
      display: flex;
    }
    .example {
      width: 100%;
      @media all and (min-width: set-bp('m')) {
        width: 260px;
      }
      height: 127px;
      &.contrast {
        background-color: set-color('blue', 700);
        border-radius: set-radius('m');
      }
      &.type--row img {
        height: 66px;
        width: auto;
      }
      &.type--break img {
        height: 95px;
        width: auto;
      }
      &.type--plus img {
        width: 240px;
        height: auto;
      }
    }
    .meta {
      margin-top: set-gutter('xl');
      @media all and (min-width: set-bp('m')) {
        margin-top: 0;
      }
    }
  }
}
</style>
